export const businessDetailTranslations = {
  en: {
    'businessDetail.transactionSummary': 'Transaction Summary',
    'businessDetail.totalTransactions': 'Total Transactions',
    'businessDetail.totalAmount': 'Total Amount',
    'businessDetail.lastTransaction': 'Last Transaction',
    'businessDetail.payAgain': 'Pay Again',
    'businessDetail.schedule': 'Schedule',
    'businessDetail.transactionHistory': 'Transaction History',
    'businessDetail.payment': 'payment',
  },
  es: {
    'businessDetail.transactionSummary': 'Resumen de Transacciones',
    'businessDetail.totalTransactions': 'Transacciones Totales',
    'businessDetail.totalAmount': 'Monto Total',
    'businessDetail.lastTransaction': 'Última Transacción',
    'businessDetail.payAgain': 'Pagar de Nuevo',
    'businessDetail.schedule': 'Programar',
    'businessDetail.transactionHistory': 'Historial de Transacciones',
    'businessDetail.payment': 'pago',
  },
  fr: {
    'businessDetail.transactionSummary': 'Résumé des transactions',
    'businessDetail.totalTransactions': 'Total des transactions',
    'businessDetail.totalAmount': 'Montant total',
    'businessDetail.lastTransaction': 'Dernière transaction',
    'businessDetail.payAgain': 'Payer à nouveau',
    'businessDetail.schedule': 'Planifier',
    'businessDetail.transactionHistory': 'Historique des transactions',
    'businessDetail.payment': 'paiement',
  },
  sq: {
    'businessDetail.transactionSummary': 'Përmbledhja e Transaksioneve',
    'businessDetail.totalTransactions': 'Transaksionet Totale',
    'businessDetail.totalAmount': 'Shuma Totale',
    'businessDetail.lastTransaction': 'Transaksioni i Fundit',
    'businessDetail.payAgain': 'Paguaj Përsëri',
    'businessDetail.schedule': 'Programo',
    'businessDetail.transactionHistory': 'Historia e Transaksioneve',
    'businessDetail.payment': 'pagesë',
  },
  ru: {
    'businessDetail.transactionSummary': 'Сводка транзакций',
    'businessDetail.totalTransactions': 'Всего транзакций',
    'businessDetail.totalAmount': 'Общая сумма',
    'businessDetail.lastTransaction': 'Последняя транзакция',
    'businessDetail.payAgain': 'Оплатить снова',
    'businessDetail.schedule': 'Запланировать',
    'businessDetail.transactionHistory': 'История транзакций',
    'businessDetail.payment': 'платеж',
  },

  de: {
    'businessDetail.transactionSummary': 'Transaktionsübersicht',
    'businessDetail.totalTransactions': 'Gesamttransaktionen',
    'businessDetail.totalAmount': 'Gesamtbetrag',
    'businessDetail.lastTransaction': 'Letzte Transaktion',
    'businessDetail.payAgain': 'Erneut zahlen',
    'businessDetail.schedule': 'Planen',
    'businessDetail.transactionHistory': 'Transaktionsverlauf',
    'businessDetail.payment': 'Zahlung',
  },

  sr: {
    'businessDetail.transactionSummary': 'Преглед трансакција',
    'businessDetail.totalTransactions': 'Укупне трансакције',
    'businessDetail.totalAmount': 'Укупан износ',
    'businessDetail.lastTransaction': 'Последња трансакција',
    'businessDetail.payAgain': 'Плати поново',
    'businessDetail.schedule': 'Закажи',
    'businessDetail.transactionHistory': 'Историја трансакција',
    'businessDetail.payment': 'плаћање',
  },
  pl: {
    'businessDetail.transactionSummary': 'Podsumowanie Transakcji',
    'businessDetail.totalTransactions': 'Wszystkie Transakcje',
    'businessDetail.totalAmount': 'Całkowita Kwota',
    'businessDetail.lastTransaction': 'Ostatnia Transakcja',
    'businessDetail.payAgain': 'Zapłać Ponownie',
    'businessDetail.schedule': 'Zaplanuj',
    'businessDetail.transactionHistory': 'Historia Transakcji',
    'businessDetail.payment': 'płatność',
  },
  el: {
    'businessDetail.transactionSummary': 'Περίληψη Συναλλαγών',
    'businessDetail.totalTransactions': 'Συνολικές Συναλλαγές',
    'businessDetail.totalAmount': 'Συνολικό Ποσό',
    'businessDetail.lastTransaction': 'Τελευταία Συναλλαγή',
    'businessDetail.payAgain': 'Πληρώστε Ξανά',
    'businessDetail.schedule': 'Προγραμματισμός',
    'businessDetail.transactionHistory': 'Ιστορικό Συναλλαγών',
    'businessDetail.payment': 'πληρωμή',
  },
  ro: {
    'businessDetail.transactionSummary': 'Rezumat Tranzacții',
    'businessDetail.totalTransactions': 'Total Tranzacții',
    'businessDetail.totalAmount': 'Suma Totală',
    'businessDetail.lastTransaction': 'Ultima Tranzacție',
    'businessDetail.payAgain': 'Plătește Din Nou',
    'businessDetail.schedule': 'Programează',
    'businessDetail.transactionHistory': 'Istoric Tranzacții',
    'businessDetail.payment': 'plată',
  },
  pt: {
    'businessDetail.transactionSummary': 'Resumo de Transações',
    'businessDetail.totalTransactions': 'Total de Transações',
    'businessDetail.totalAmount': 'Valor Total',
    'businessDetail.lastTransaction': 'Última Transação',
    'businessDetail.payAgain': 'Pagar Novamente',
    'businessDetail.schedule': 'Agendar',
    'businessDetail.transactionHistory': 'Histórico de Transações',
    'businessDetail.payment': 'pagamento',
  },
};
